import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";

const initialState = {
  pharmacy: null,
  pharmacies: [],
  isLoading: false,
  error: null,
  totalPages: 1,
};

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const createPharmacy = createAsyncThunk(
  "pharmacy/createPharmacy",
  async (data, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.post(`${ADMIN_URL}/pharmacy`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const updatePharmacy = createAsyncThunk(
  "pharmacy/updatePharmacy",
  async ({ id, data }, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.patch(`${ADMIN_URL}/pharmacy/${id}`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return {id,data};
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const getPharmacyById = createAsyncThunk(
  "pharmacy/getPharmacyById",
  async (id, { rejectWithValue ,dispatch}) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/pharmacy/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const getAllPharmacies = createAsyncThunk(
  "pharmacy/getAllPharmacies",
  async ({ page, limit ,sortBy,order,locationId}, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/pharmacy?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
          tenantId: Cookies.get("TenantId"),
          ...(locationId ? { "location-id": locationId } : {}),
        },
      });
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);


const pharmacySlice = createSlice({
  name: "pharmacy",
  initialState,
  reducers: {
    clearPharmacyError:(state)=>{
        state.error=null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPharmacy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPharmacy.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createPharmacy.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePharmacy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePharmacy.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.pharmacies.findIndex(
          (pharmacy) =>  pharmacy._id === action.payload.id
        );
        if (index !== -1) {
          state.pharmacies[index] = {
            ...state.pharmacies[index],
            ...action.payload.data,
          };
        }
        state.pharmacy = action.payload;
      })
      .addCase(updatePharmacy.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPharmacyById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPharmacyById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pharmacy = action.payload;
      })
      .addCase(getPharmacyById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAllPharmacies.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllPharmacies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pharmacies = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getAllPharmacies.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },

  
});
 export const { clearPharmacyError } = pharmacySlice.actions;
export default pharmacySlice.reducer;
